import ServiceCategoryPage from "../components/ServiceCategoryPage";
import masonMistriService from "../data/services/masonMistriService";

function MasonMistri() {
  return <ServiceCategoryPage service={masonMistriService} />;
}

export default MasonMistri;